import { useQuery } from "@tanstack/react-query";
import { fetchAuditRoles, FetchAuditRolesResponse, FetchRolesParams } from "PFCore/services/roles";
import { QueryOptions } from "PFTypes/request_options";

import { auditRolesKeys } from "./query_keys";

type UseAuditRoles = {
  params: FetchRolesParams;
  options: QueryOptions<FetchAuditRolesResponse>;
};

export const useAuditRoles = ({ params, options = {} }: UseAuditRoles) =>
  useQuery<FetchAuditRolesResponse>({
    queryKey: auditRolesKeys.list(params),
    queryFn: () => fetchAuditRoles(params),
    ...options
  });
